import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/chat";

const put = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/putMessages", payload);
}

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

const getById = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/getById", payload);
}

const read = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/read", payload);
}

const closeChat = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/closeChat", payload);
}

const countReadable = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/countReadable", payload);
}

const chatApi = {
    put,
    search,
    getById,
    read,
    closeChat,
    countReadable
}

export default chatApi;